const RECORD_TEXT = '仅销售预包装食品备案编号:YB23702810046709';
const LICENSE_TEXT = '食品经营许可证';
const LICENSE_IMG = '/asset/img/zj/spjy.jpg';

function createRecordNode(sourceNode) {
  const record = document.createElement('span');
  record.textContent = RECORD_TEXT;
  record.style.cursor = 'default';

  if (sourceNode && sourceNode.className) {
    record.className = sourceNode.className;
  }

  return record;
}

function replaceNode(sourceNode) {
  if (!sourceNode || !sourceNode.parentNode) {
    return;
  }

  sourceNode.parentNode.replaceChild(createRecordNode(sourceNode), sourceNode);
}

function replaceFoodLicenseRecord() {
  if (!document.body) {
    return;
  }

  Array.from(document.querySelectorAll('a')).forEach((node) => {
    const href = node.getAttribute('href') || '';
    const text = (node.textContent || '').trim();

    if (href.indexOf(LICENSE_IMG) !== -1 || text.indexOf(LICENSE_TEXT) !== -1) {
      replaceNode(node);
    }
  });

  Array.from(document.querySelectorAll('span, div')).forEach((node) => {
    const text = (node.textContent || '').trim();

    if (text === LICENSE_TEXT) {
      replaceNode(node.closest('a') || node);
    }
  });
}

export function installFoodLicenseRecordPatch() {
  replaceFoodLicenseRecord();

  if (!window.MutationObserver || !document.body) {
    return;
  }

  const observer = new MutationObserver(() => {
    replaceFoodLicenseRecord();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}
